import {
  IMobilityPexRootState,
  IMpexDynamic5gCustomerLayoutProps,
  MpexWebComponentEvents,
  MpexWebComponentInteractions,
} from '@telstra-connect/mobility-pex/type';
import {
  requestNotStarted,
  requestStarted,
  requestSucceeded,
} from '@telstra-connect/utils/data/request-helpers';
import * as React from 'react';
import { useSelector } from 'react-redux';
import OrderLoading from '../../../order-details-loading';
import OrderDetailsError from '../../../order-details-error';
import {
  FeatureFlagNames,
  withBvtFlagsChecker,
} from '@utils/bvt-feature-flags';
import { Application } from '@applications/order-tracker';
import { Components } from '@telstra-connect/order-tracker/activity-tracking';

declare global {
  namespace JSX {
    // tslint:disable-next-line:interface-name
    interface IntrinsicElements {
      'mpex-dynamic-5g-customer-layout-v1': IMpexDynamic5gCustomerLayoutProps;
    }
  }
}

const handleTracking = (intent: string, sliceId?: string) => {
  Application.tracker.trackLink(
    Components.mpexDetailsPage,
    `mpex/${intent}${sliceId ? '/sliceid:' + sliceId : ''}`
  );
};

const MobilityPexOrderDetails = ({
  orderNumber,
  cidn,
}: {
  orderNumber: string;
  cidn: string;
}) => {
  const componentRef = React.useRef(null);
  const mobilityPex = useSelector(
    (state: IMobilityPexRootState) => state.mobilityPex
  );
  React.useEffect(() => {
    const component = componentRef.current;
    if (!component) {
      return;
    }

    const handleOnInteraction = ({
      detail,
    }: {
      detail: {
        intent: string;
        data?: {
          sliceId?: string;
        };
      };
    }) => {
      if (!detail || !detail.intent) {
        return;
      }
      handleTracking(detail.intent, detail.data?.sliceId);
      if (detail.intent.endsWith(MpexWebComponentInteractions.goToHome)) {
        location.href = '/app/dashboard';
      }
    };

    component.addEventListener(
      MpexWebComponentEvents.interaction,
      handleOnInteraction
    );
    return () => {
      component.removeEventListener(
        MpexWebComponentEvents.interaction,
        handleOnInteraction
      );
    };
  }, [componentRef]);
  if (!orderNumber || !cidn) {
    return null;
  }

  return (
    <React.Fragment>
      {requestSucceeded(mobilityPex) ? (
        <mpex-dynamic-5g-customer-layout-v1
          ref={componentRef}
          cidn={cidn}
          orderId={orderNumber}
          view={'ORDER_TRACKER'}
        />
      ) : requestStarted(mobilityPex) || requestNotStarted(mobilityPex) ? (
        <OrderLoading />
      ) : (
        <OrderDetailsError />
      )}
    </React.Fragment>
  );
};

export default withBvtFlagsChecker(MobilityPexOrderDetails, OrderDetailsError, {
  bvtFlagName: FeatureFlagNames.tedig4307Dynamic5g,
});
